<ng-container *transloco="let t">
    <!-- Button -->
    <button mat-icon-button [matTooltip]="tooltip || t('configs.toggle_fullscreen')" (click)="toggleFullscreen()">
        <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
    </button>

    <!-- Default icon -->
    <ng-template #defaultIconTpl>
        <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
    </ng-template>
</ng-container>
